export const ventures = [
  {
    slug: "infantry-financial",
    name: "Infantry Financial",
    short: "Infantry",
    kind: "Business",
    sector: "Credit Repair Organization",
    url: "https://www.infantry-financial.com",
    display: "infantry-financial.com",
    image: "/images/infantry.jpg",
    logo: "/images/logos/infantry.png",
    accent: "#5B9BFF",
    tagline: "Your Credit. Rebuilt with Military Precision.",
    intro:
      "Infantry Financial helps real people in Texas restore their credit, qualify for loans, and achieve financial freedom — with discipline, transparency, and zero empty promises.",
    offeringsLabel: "Services",
    offerings: [
      "Credit Restoration Consulting",
      "Credit-Building Strategy",
      "Lender-Ready Preparation",
      "Budget & DTI Analysis",
    ],
    facts: [
      { label: "Clients helped", value: "500+" },
      { label: "Years in business", value: "8" },
      { label: "Client rating", value: "4.9" },
    ],
    details: [
      { label: "Serving", value: "Texas, USA" },
      { label: "Hours", value: "Mon–Sat · 9–5 CT" },
      { label: "Email", value: "infantryfinancial@gmail.com" },
      { label: "Compliance", value: "CROA · FCRA" },
    ],
  },
  {
    slug: "coastal-bend-contractor",
    name: "Coastal Bend Contractor Co.",
    short: "Coastal Bend",
    kind: "Business",
    sector: "Custom Homes & Renovation",
    url: "https://www.coastalbendcontractor.com",
    display: "coastalbendcontractor.com",
    image: "/images/coastal.jpg",
    logo: "/images/logos/coastal.png",
    accent: "#5B9BFF",
    tagline: "Built for the Texas Gulf Coast. Built to last a generation.",
    intro:
      "Coastal Bend Contractor designs and builds custom homes and renovations engineered for Gulf Coast living.",
    offeringsLabel: "What we build",
    offerings: ["Custom New Homes", "Kitchen & Bath Remodels", "Full-Home Renovations"],
    facts: [],
    details: [
      { label: "Based in", value: "Corpus Christi, Nueces County, TX" },
      { label: "Phone", value: "(361) 833-1309" },
      { label: "Email", value: "info@coastalbendcontractor.com" },
    ],
  },
  {
    slug: "dextyou",
    name: "Dextyou",
    short: "Dextyou",
    kind: "Business",
    sector: "App · Contacts & Networking",
    url: "https://www.dextyou.com",
    display: "dextyou.com",
    image: "/images/dextyou.jpg",
    logo: "/images/logos/dextyou.png",
    accent: "#5B9BFF",
    tagline: "Let Me Dextyou.",
    intro:
      "Dextyou turns a photo of any business card into an organized, searchable contact — so you capture, organize, and act on the people you meet, and never lose a connection again.",
    offeringsLabel: "Features",
    offerings: [
      "AI scan, front & back",
      "Find anyone fast",
      "Share in a tap — QR, vCard, SMS or email",
      "Follow-up reminders so you never drop a lead",
      "Bulk-scan up to 20 cards at once",
    ],
    facts: [
      { label: "Monthly", value: "$0.99" },
      { label: "Yearly", value: "$9.99" },
    ],
    details: [{ label: "Platform", value: "Mobile app" }],
  },
  {
    slug: "epic-foundation",
    name: "E.P.I.C. Foundation",
    short: "E.P.I.C.",
    kind: "Charity",
    sector: "Every Person Is Considered",
    url: "https://epic-foundation.org",
    display: "epic-foundation.org",
    image: "/images/foundation.jpg",
    logo: "/images/logos/foundation.png",
    accent: "#5B9BFF",
    tagline: "Every Person Is Considered.",
    intro:
      "The E.P.I.C. Foundation enhances the quality of life for elderly and veteran community members through compassionate home modifications — so they can live independently and safely in their own homes.",
    offeringsLabel: "Programs",
    offerings: [
      "Bathroom Safety Solutions",
      "Mobility Support Systems",
      "Personalized Solutions",
      "Additional Services",
    ],
    facts: [],
    details: [
      { label: "Address", value: "605 NAS St. Corpus Christi, TX 78418" },
      { label: "Serving", value: "Elderly & veteran neighbors" },
    ],
  },
  {
    slug: "epic-community-throwdown",
    name: "EPIC Community Throwdown",
    short: "Throwdown",
    kind: "Charity",
    sector: "Charity Dodgeball Tournament",
    url: "https://www.epiccommunitythrowdown.com",
    display: "epiccommunitythrowdown.com",
    image: "/images/throwdown.jpg",
    logo: "/images/logos/throwdown.png",
    accent: "#5B9BFF",
    tagline: "Where businesses battle. The community wins.",
    intro:
      "A quarterly, smack-talking, trophy-traveling dodgeball tournament benefiting the E.P.I.C. Foundation. One day. One trophy. One cause — local businesses compete for a traveling trophy while supporting the community.",
    offeringsLabel: "On the day",
    offerings: [
      "Live DJ",
      "Food Trucks & Drinks",
      "Awards & Prizes",
      "Family Fun & Activities",
      "EPIC Photos & Highlights",
    ],
    facts: [
      { label: "Team slots", value: "24+" },
      { label: "Team entry", value: "$600" },
    ],
    details: [
      { label: "Format", value: "Double Elimination · All-Day" },
      { label: "Venue", value: "Corpus Christi Athletic Club, 2101 Airline Rd" },
      { label: "Benefits", value: "E.P.I.C. Foundation" },
    ],
  },
];

export const getVenture = (slug) => ventures.find((v) => v.slug === slug);
